import React, { Fragment } from 'react';
import { config } from 'helpers';
import { Header, Badge, Button, Image } from 'components';
import css from './outro.scss';

export function Outro(props) {
  return (
    <div className={css.section}>
      <div className={css.container}>
        { props.children || defaultContent() }
        <p><Button to="/sign-up/?redirect=/settings/membership/" white square className={css.button}>Start { config.trialPeriod }</Button></p>
        <ul className={css.buttonContainer}>
          <li><Badge.AppStore className={css.badge} /></li>
          <li><Badge.GooglePlay className={css.badge} /></li>
        </ul>
      </div>
    </div>
  );
}

function defaultContent() {
  return (
    <Fragment>
      <h3>
        Time to Accomplish More, Experience More, Live More?
        Start your new Life Journey - Today!
      </h3>
      <p>Sign up for your complimentary access to a set of tools and applications.</p>
    </Fragment>
  );
}
